import React, { useEffect, useState } from "react";
import TitleBtnFragment from "../../../components/fragment/title-btn/TitleBtnFragment";
import "../../../styles/dashboard/roles/RolesIndex.css";
import DashboardLayoutMain from "../../../layout/dashboard/DashboardLayoutMain";
import {
  RazorCheckBox,
  RazorInputField,
  RazorToggleSlide,
} from "../../../components/razor-reuse";
import { useDispatch, useSelector } from "react-redux";
import { createRoleFunc, getModulePermissions } from "../../../redux/role";
import RootState from "../../../redux/type";
import { getAllAdminUsers } from "../../../redux/users";
import { useNavigate } from "react-router-dom";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { hasSpecialCharactersOrNumbers } from "../../../utils/Helper";

const AddRoleIndex = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading_modules, module_permission, loading_create } = useSelector(
    (state: RootState) => state.roles
  );
  const { admin_users } = useSelector((state: RootState) => state.users);

  type detailProps = {
    name: string;
    permissions: string[];
    users: string[];
    description: string;
  };
  const [details, setDetails] = useState<detailProps>({
    name: "",
    permissions: [],
    users: [],
    description: "",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    const obj = { ...details, [name]: value };
    setDetails(obj);
  };

  const handleAddToList = (param: string) => {
    // let newList;
    if (details?.permissions?.includes(param)) {
      const newList = details?.permissions?.filter(
        (chi: string) => chi !== param
      );
      setDetails((prev) => {
        return { ...prev, permissions: newList };
      });
    } else {
      const newList = [...details?.permissions, param];
      setDetails((prev) => {
        return { ...prev, permissions: newList };
      });
    }
  };

  useEffect(() => {
    if (module_permission?.length < 1) {
      dispatch(getModulePermissions({}) as any);
    }
    if (admin_users?.length < 1) {
      dispatch(getAllAdminUsers({}) as any);
    }
  }, [dispatch, module_permission?.length, admin_users?.length]);

  const filterListFunc = (list: any) => {
    if (list?.length > 0) {
      const filterList = list?.filter((chi: any) => chi?.status !== "Pending");
      // console.log(filterList);
      return filterList;
    }
  };

  const getListUserId = (list: any) => {
    if (list?.length > 0) {
      const newList = list?.map((chi: any) => chi?.id);
      return newList;
    }
  };

  const handleSubmit = async () => {
    const obj = {
      ...details,
      users: getListUserId(details?.users),
    };
    const data = await dispatch(createRoleFunc(obj) as any);

    if (data?.payload?.data?.status) {
      setDetails({
        name: "",
        permissions: [],
        users: [],
        description: "",
      });
      navigate(ALL_ROUTES?.DASHBOARD_ROLES);
    }
  };

  // This creates an array of all permission for "assign All Roles"
  const list = module_permission?.flatMap((item: any) =>
    item?.permissions?.map((val: any) => val?.name)
  );
  // This triggers button to "assign All Roles"
  const handleToggleAssignAll = (status: boolean) => {
    if (status) {
      setDetails((prev) => {
        return { ...prev, permissions: [] };
      });
    } else {
      setDetails((prev) => {
        return { ...prev, permissions: list };
      });
    }
  };

  return (
    <>
      <DashboardLayoutMain
        loading={module_permission?.length < 1 && loading_modules}
        title="Add Role"
        back
      >
        {/* title fragment start */}
        {/* <TitleBtnFragment
          className="title-btn"
          //   hideBtn
        //   title="Add New Role"
          btnLabel="Create Role"
          sticky
        /> */}
        {/* title fragment end */}
        {/* add new role index wrap start */}
        <div
          onClick={() => {
            // console.log(module_permission);
          }}
          className="add-new-role-index-wrap-smart-send-box"
        >
          <div className="form-box">
            {/* title fragment start */}
            <TitleBtnFragment
              loadingText="Creating role"
              className="title-btn"
              disable={
                !details?.description ||
                !details?.name ||
                details?.permissions?.length < 1
              }
              btnLabel="Create Role"
              sticky
              onBtnClick={() => {
                handleSubmit();
              }}
              loading={loading_create}
            />
            {/* title fragment end */}
            {/* two form group start */}
            <div className="two-form-group-box">
              <RazorInputField
                color="black-light"
                placeholder="Enter role name"
                label="Role Name"
                onChange={(e: any) => {
                  if (hasSpecialCharactersOrNumbers(e.target.value)) {
                    return;
                  }
                  handleChange(e);
                }}
                name="name"
                value={details?.name}
                capitalize
              />
            </div>
            <RazorInputField
              color="black-light"
              placeholder="Select Team Member"
              label="Team Members"
              type="select"
              value={details?.users}
              onChange={(e: any) => {
                setDetails((prev) => {
                  return { ...prev, users: e };
                });
              }}
              selectOption={filterListFunc(admin_users)}
              multi={true}
              style={{ position: "relative", zIndex: 10 }}
            />
            {/* two form group end */}
            <RazorInputField
              color="black-light"
              type="textarea"
              label="Description"
              placeholder="Enter Description"
              onChange={handleChange}
              name="description"
              value={details?.description}
              capitalize
            />

            <div className="role-permission-wrap-box">
              <div className="flex items-center justify-between gap-x-[50px]">
                <p className="header-title">Defined Permissions:</p>
                <figure className="inline-flex items-center gap-x-[10px] px-[16px] py-[8px] rounded-[8px] border-primary">
                  <RazorToggleSlide
                    checked={list?.length === details?.permissions?.length}
                    onChange={() => {
                      handleToggleAssignAll(
                        list?.length === details?.permissions?.length
                      );
                    }}
                    id={"all"}
                    color={`black-light`}
                  />
                  <p className=" text-[14px]">Assign all roles</p>
                </figure>
              </div>

              {/* module permissions box wrap start */}
              <div className="module-permissions-box-wrap">
                {module_permission?.map((chi: any, idx: any) => {
                  // Check if all permissions in the category are checked
                  const allCategoryChecked = chi?.permissions?.every(
                    (child: any) => {
                      return details?.permissions?.includes(child?.name);
                    }
                  );

                  // Extract the names from the permission array
                  const permissionNames = chi?.permissions?.map(
                    (child: any) => child?.name
                  );

                  const handleAddAllToList = () => {
                    if (allCategoryChecked) {
                      const newList = details?.permissions?.filter(
                        (child: any) => !permissionNames?.includes(child)
                      );
                      setDetails((prev) => {
                        return { ...prev, permissions: newList };
                      });
                    } else {
                      const newList = [
                        ...details?.permissions,
                        ...permissionNames,
                      ];
                      setDetails((prev) => {
                        return { ...prev, permissions: newList };
                      });
                    }
                  };

                  return (
                    <div key={idx} className="module-permissions-box">
                      <p
                        style={{ textTransform: "capitalize" }}
                        className="module-name"
                      >
                        {chi?.category}
                        <RazorToggleSlide
                          checked={allCategoryChecked}
                          onChange={handleAddAllToList}
                          id={`${idx}-${chi?.category}` as any}
                          color={`black-light`}
                        />
                      </p>
                      {/* permissions box wrap start */}
                      <div className="permission-box-wrap">
                        {chi?.permissions?.map((child: any, i: any) => {
                          return (
                            <div key={`${idx}-${i}`} className="permission-box">
                              <p
                                style={{ textTransform: "capitalize" }}
                                className="name"
                              >
                                {child?.name}
                              </p>
                              <RazorCheckBox
                                checked={details?.permissions?.includes(
                                  child?.name
                                )}
                                onChange={() => {
                                  handleAddToList(child?.name);
                                }}
                                id={`${idx}-${i}-${child?.name}` as any}
                                color="black-light"
                                key={`${idx}-${i}-${child?.name}` as any}
                              />
                            </div>
                          );
                        })}
                      </div>
                      {/* permissions box wrap end */}
                    </div>
                  );
                })}
              </div>
              {/* module permissions box wrap end */}
            </div>
          </div>
          {/* form box end */}
        </div>
        {/* add new role index wrap end */}
      </DashboardLayoutMain>
    </>
  );
};

export default AddRoleIndex;
